import React from 'react';

import { isDefined } from '@nfctron/nexus-core';
import { type ExtendedComponent, UiButton, cn } from '@nfctron/nexus-react';

import { Text } from '@mantine/core';
import { ChevronDownIcon } from 'lucide-react';

/**
 * Event/Cart/ProductConfigItem component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const ProductConfigItem: React.FunctionComponent<ProductConfigItemProps> = ({ onSelect, term, value, className, ...props }) => (
	<div className="flex items-start gap-1" {...props}>
		<Text c="dimmed" size="md" style={{ whiteSpace: 'nowrap' }}>
			{term}:
		</Text>
		<UiButton
			color="unstyled"
			variant="unstyled"
			size="unstyled"
			className={cn(['h-[22px]! bg-zinc-50! px-1 font-normal! text-purple-600', !isDefined(onSelect) && 'cursor-default!', className])}
			{...(isDefined(onSelect) && {
				rightSection: <ChevronDownIcon className="size-3 text-purple-600" />,
				onClick: onSelect,
			})}
		>
			{value}
		</UiButton>
	</div>
);

/**
 * Event/Cart/ProductConfigItem component props type
 * @private
 */
type ProductConfigItemProps = ExtendedComponent<{
	term: React.ReactNode;
	value: React.ReactNode;
	onSelect?: () => void;
}>;

/**
 * Event/Cart/ProductConfigItem component display name
 * @type {ComponentDisplayName}
 */
ProductConfigItem.displayName = 'Event/Cart/ProductConfigItem';
